<div class="slider-container">

  <!-- LEFT NAV -->
  <div class="nav left"
       (click)="prev()"
       [class.disabled]="currentPage === 0">
    <mat-icon>chevron_left</mat-icon>
  </div>

  



  <!-- VIEWPORT -->
  <div class="slider-viewport">
    <ng-container *ngIf="staticTemplate">
      <ng-container *ngTemplateOutlet="staticTemplate">
      </ng-container>
    </ng-container>
    <div class="slider-track"
         [style.transform]="'translateX(-' + translateX + '%)'">
      @for (page of [].constructor(totalPages); track $index; let i = $index) {
      <div class="slider-page">
        @for(item of items.slice(i * pageSize, (i + 1) * pageSize); track $index; let j = $index) {
        <ng-container>
          <!-- projected content -->
          <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: item}">
          </ng-container>

        </ng-container>
        }
      </div>
      }
    </div>
  </div>

  <!-- RIGHT NAV -->
  <div class="nav right"
       (click)="next()"
       [class.disabled]="currentPage >= totalPages - 1">
    <mat-icon>chevron_right</mat-icon>
  </div>

</div>
